import { SSOLoginResponse } from '@/types/loginResponse'
import { AuthenticationResult } from '@/types/authenticationResult'
import { TotpState } from '@/types/totpState'

type TotpHttpLogin = (username: string, session: string, code: string) => Promise<SSOLoginResponse>
type RedirectToRetrieveToken = (authenticationResult: AuthenticationResult) => Promise<void>
type ChallengeHandler = (username: string, loginResponse: SSOLoginResponse, redirectUrlAfterLogin: string) => void
type UpdatePasswordHandler = (accessToken: string, redirectUrlAfterLogin: string) => void

const state: TotpState = {
  username: undefined,
  session: undefined,
  redirectUrlAfterLogin: undefined
}

export const isTotpInitialized = () => {
  return state.session && state.username && state.redirectUrlAfterLogin
}

export const initTotp = (username: string, session: string, redirectUrlAfterLogin: string) => {
  state.username = username
  state.session = session
  state.redirectUrlAfterLogin = redirectUrlAfterLogin
}

export const totpLoginFlow = (totpLoginHttp: TotpHttpLogin, redirectToRetrieveToken: RedirectToRetrieveToken, challengeHandler: ChallengeHandler, updatePasswordHandler: UpdatePasswordHandler) =>
  async (code: string) => {
    if (!state.session || !state.username || !state.redirectUrlAfterLogin) {
      throw Error('Must set username and session before login with totp')
    }

    const loginResponse = await totpLoginHttp(state.username, state.session, code)

    if (loginResponse.code === 'PasswordExpired' && !loginResponse.mfaRequired) {
      // We set the email and accessToken in the sessionStorage just to uses it in the changePassword in case the user do a refresh in the page.
      window.sessionStorage.setItem('email', state.username)
      window.sessionStorage.setItem('accessToken', loginResponse.accessToken)

      return updatePasswordHandler(loginResponse.accessToken, state.redirectUrlAfterLogin)
    }

    loginResponse.ChallengeName
      ? challengeHandler(state.username, loginResponse, state.redirectUrlAfterLogin)
      : redirectToRetrieveToken(loginResponse.AuthenticationResult)
  }

export const getTotpState = () => state
